import { ref } from 'vue'

// Global singleton state
const isVisible = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')
const errorButtonText = ref('')

export const useFormErrorModal = () => {
  const showError = (title?: string, message?: string, buttonText?: string) => {
    errorTitle.value = title || 'Oops, something went wrong!'
    errorMessage.value = message || 'An error occurred. Please try again.'
    errorButtonText.value = buttonText || 'Try again'
    isVisible.value = true
  }

  const hideError = () => {
    isVisible.value = false
  }

  return {
    isVisible,
    errorTitle,
    errorMessage,
    errorButtonText,
    showError,
    hideError,
  }
}
